import styled from "styled-components";

export default styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 0;
  width: 60%;
  @media (max-width: 480px) {
    width: 100%;
  }
`;
